import { Component, Input, OnInit } from '@angular/core';
import * as dayjs from 'dayjs';
import { AppHotelService } from 'src/app/provider/app-hotel.service';
import { AWSService } from 'src/app/provider/aws.service';
import { RequestsService } from 'src/app/provider/requests.service';
import { AppHotelModel } from 'src/app/views/models/app-hotel.model';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import pdfMake from 'pdfmake/build/pdfmake';
import { BehaviorSubject } from 'rxjs';
import { RequestLineModel } from 'src/app/views/models/request-line.model';
import { RequestHeaderModel } from 'src/app/views/models/request-header.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'kt-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent implements OnInit {

  @Input() popupVisible = false;
  @Input() currentRequest: RequestHeaderModel;

  currentRequestRedeem: RequestLineModel = new RequestLineModel();
  currentHotelInfo: AppHotelModel;


  is_processing = new BehaviorSubject<boolean>(false);
  quest_mark = new BehaviorSubject<boolean>(true);
  completed = new BehaviorSubject<boolean>(false);



  guest_visible = true;
  popupVisibleRedeem = false;

  total = 0;
  rate: number;
  time = new Date().getTime();
  private edit = false;

  today = dayjs(new Date()).format('DD-MM-YYYY');



  constructor(public requestService: RequestsService, private awsServ: AWSService, private appHotel: AppHotelService,
    private translateServ: TranslateService



  ) {
    this.guest_visible = JSON.parse(localStorage.getItem('token_form')).guest_visible;
    this.appHotel.getHotelInfo(+localStorage.getItem('hotelId')).subscribe(
      (hotelInfo: AppHotelModel) => {
        this.currentHotelInfo = hotelInfo;
      }
    );
  }

  async ngOnInit() {
    console.log("request component");
    

  }

  translateVariable(variable) {
    let translateVariable;
    this.translateServ.get(variable).subscribe((text: string) => { translateVariable = text; });
    return translateVariable;
  }

  expiredGift(date: Date) {
    const today = dayjs(new Date());
    if (dayjs(date).isBefore(today) && today.diff(date, 'day') !== 0) {
      return true;
    }
    return false;
  }

  changepopupVisibleRedeem() {
    this.popupVisibleRedeem = false;
  }

  completeRedeem(id: string) {
    this.quest_mark.next(false);
    this.is_processing.next(true);
    setTimeout(() => {
      // this.completed.next(true);
      this.requestService.putRedeemStatus(id).then((res: { line }) => {
        if (res) {
          this.currentRequestRedeem = res.line;
          this.is_processing.next(false);
          this.quest_mark.next(true);
        }
      });

    }, 1500);
  }


  close() {
    this.popupVisibleRedeem = false;
  }




  ShowRedeem(data) {
    // this.requestService.getRequestById(data.data.request_header_id)
    console.log(data);
    this.currentRequestRedeem = data.data;
    this.popupVisibleRedeem = true;

  }

  getVisible(name: string) {
    let first: string = name.substring(0, 1);
    for (let i = 1; name.length > i; i++) {
      first += '*';
    }
    return first;
  }

  onRowPrepared(e) {
    if (e.rowType == 'data' && e.data.status == 'Finished') {
      e.rowElement.style.backgroundColor = '#32cd3259';
    }
  }

  onChange(type, value) {
    const oldDate = new Date(this.currentRequest.order_date);
    switch (type) {
      case 'hour':
        const requestTime = new Date(oldDate.getFullYear(), oldDate.getMonth(), oldDate.getDate(), +value.split(':')[0], +value.split(':')[1]);
        this.currentRequest.order_date = requestTime;
        break;
      case 'date':
        const requestDate = new Date(value.split('/')[2], value.split('/')[1], value.split('/')[0], oldDate.getHours(), oldDate.getMinutes());
        this.currentRequest.order_date = requestDate;
        break;
    }
    this.requestService.putRequest(this.currentRequest);
    this.edit = true;
  }


  async generatePdf() {
    const IMG = await this.awsServ.getBase64('https://b1development.s3.eu-central-1.amazonaws.com/icibotV2/' + this.currentRequest.hotel_id + '/DarkLogo/' + this.currentRequest.hotel_id + '.jpg?' + this.time);



    const LINES: any = [
      [
        {
          text: this.translateVariable('ITEM DESCRIPTION'),
          fillColor: '#eaf2f5',
          border: [false, true, false, true],
          margin: [0, 5, 0, 5],
          textTransform: 'uppercase',
        },
        {
          text: this.translateVariable('ITEM TOTAL'),
          border: [false, true, false, true],
          alignment: 'right',
          fillColor: '#eaf2f5',
          margin: [0, 5, 0, 5],
          textTransform: 'uppercase',
        }
      ]
    ];

    const COLUMNS = [];

    this.currentRequest.requestlines.forEach(item => {

      LINES.push(
        [
          {
            text: item.name.replace(/<\/?[^>]+>/gi, '') + '\n' + item.note,
            border: [false, false, false, true],
            margin: [0, 5, 0, 5],
            alignment: 'left',
          },
          {
            border: [false, false, false, true],
            text: `${item.currency_code}${item.amount}`,
            fillColor: '#f5f5f5',
            alignment: 'right',
            margin: [0, 5, 0, 5],
          }
        ]
      );
    });

    const PDF = {
      content: [
        {
          columns: [
            {
              image: IMG,
              width: 150,
            },
            [
              {
                text: this.translateVariable('RECEIPT'),
                color: '#333333',
                width: '*',
                fontSize: 20,
                bold: true,
                alignment: 'right',
                margin: [0, 0, 0, 15],
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: this.translateVariable('ID'),
                        color: '#aaaaab',
                        bold: true,
                        width: '*',
                        fontSize: 12,
                        alignment: 'right',
                      },
                      {
                        text: this.currentRequest.id,
                        bold: true,
                        color: '#333333',
                        fontSize: 12,
                        alignment: 'right',
                        width: 100,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: this.translateVariable('DATE ISSUED'),
                        color: '#aaaaab',
                        bold: true,
                        width: '*',
                        fontSize: 12,
                        alignment: 'right',
                      },
                      {
                        text: dayjs(this.currentRequest.created_at).format('DD/MM/YYYY'),
                        bold: true,
                        color: '#333333',
                        fontSize: 12,
                        alignment: 'right',
                        width: 100,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: this.translateVariable('STATUS'),
                        color: '#aaaaab',
                        bold: true,
                        fontSize: 12,
                        alignment: 'right',
                        width: '*',
                      },
                      {
                        text: this.translateVariable(this.currentRequest.status),
                        bold: true,
                        fontSize: 14,
                        alignment: 'right',
                        color: '#333333',
                        width: 100,
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
        {
          columns: [
            {
              text: this.translateVariable('BILL TO'),
              color: '#aaaaab',
              bold: true,
              fontSize: 14,
              alignment: 'left',
              margin: [0, 20, 0, 5],
            },
            {
              text: this.translateVariable('SHIP TO'),
              color: '#aaaaab',
              bold: true,
              fontSize: 14,
              alignment: 'left',
              margin: [0, 20, 0, 5],
            },
          ],
        },
        {
          columns: [
            {
              text: `${this.currentRequest.hotel_name}`,
              bold: true,
              color: '#333333',
              alignment: 'left',
            },
            {
              text: `${this.currentRequest.profile_name}`,
              bold: true,
              color: '#333333',
              alignment: 'left',
            },
          ],
        },
        {
          columns: [
            {
              text: this.translateVariable('ADDRESS'),
              color: '#aaaaab',
              bold: true,
              margin: [0, 7, 0, 3],
            },
            {}
          ],
        },
        {
          columns: [
            {
              text: this.currentHotelInfo.address,
              style: 'invoiceBillingAddress',
            }
          ],
        },
        '\n\n',
        {
          width: '100%',
          alignment: 'center',
          text: `${this.translateVariable('INVOICE NO')} : ${this.currentRequest.id}`,
          bold: true,
          margin: [0, 10, 0, 10],
          fontSize: 15,
        },
        {
          layout: {
            defaultBorder: false,
            hLineWidth(i, node) {
              return 1;
            },
            vLineWidth(i, node) {
              return 1;
            },
            hLineColor(i, node) {
              if (i === 1 || i === 0) {
                return '#bfdde8';
              }
              return '#eaeaea';
            },
            vLineColor(i, node) {
              return '#eaeaea';
            },
            hLineStyle(i, node) {
              return null;
            },
            paddingLeft(i, node) {
              return 10;
            },
            paddingRight(i, node) {
              return 10;
            },
            paddingTop(i, node) {
              return 2;
            },
            paddingBottom(i, node) {
              return 2;
            },
            fillColor(rowIndex, node, columnIndex) {
              return '#fff';
            },
          },
          table: {
            headerRows: 1,
            widths: ['*', 80],
            body: LINES,
          },
        },
        '\n',
        '\n\n',
        {
          layout: {
            defaultBorder: false,
            hLineWidth(i, node) {
              return 1;
            },
            vLineWidth(i, node) {
              return 1;
            },
            hLineColor(i, node) {
              return '#eaeaea';
            },
            vLineColor(i, node) {
              return '#eaeaea';
            },
            hLineStyle(i, node) {
              return null;
            },
            paddingLeft(i, node) {
              return 10;
            },
            paddingRight(i, node) {
              return 10;
            },
            paddingTop(i, node) {
              return 3;
            },
            paddingBottom(i, node) {
              return 3;
            },
            fillColor(rowIndex, node, columnIndex) {
              return '#fff';
            },
          },
          table: {
            headerRows: 1,
            widths: ['*', 'auto'],
            body: [
              [
                {
                  text: this.translateVariable('TOTAL AMOUNT'),
                  bold: true,
                  fontSize: 15,
                  alignment: 'right',
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 5],
                },
                {
                  text: `${this.currentRequest.requestlines[0].currency_code}${this.total}`,
                  bold: true,
                  fontSize: 15,
                  alignment: 'right',
                  border: [false, false, false, true],
                  fillColor: '#f5f5f5',
                  margin: [0, 5, 0, 5],
                },
              ],
            ],
          },
        },
        '\n\n',
        {
          text: this.translateVariable('NOTES'),
          style: 'notesTitle',
        },
        {
          text: this.currentRequest.note,
          style: 'notesText',
        }
      ],
      styles: {
        notesTitle: {
          fontSize: 10,
          bold: true,
          margin: [0, 20, 0, 3],
        },
        notesText: {
          fontSize: 10,
        },
      },
      defaultStyle: {
        columnGap: 20,
      },
    };

    pdfMake.createPdf(PDF).open();
  }


  startExport(event: any) {
    let description;
    this.translateServ.get('order_list').subscribe((text: string) => { description = text; });
    event.component.beginUpdate();

    event.component.columnOption('option', 'visible', false);

    event.fillPatternType = 'darkHorizontal';



    event.fileName = `${description} ${this.currentHotelInfo.name}`;
  }


  finishExport(event: any) {
    event.component.beginUpdate();

    event.component.columnOption('option', 'visible', true);


  }

}
